(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */
var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('.back-to-top-wrapper');
    this.toggleDistance = 500;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.lastScrollTop = 0;
      this.header = document.getElementsByTagName('header')[0];
      this.adminBar = document.getElementById('wpadminbar');

      if (this.adminBar) {
        this.adminBarHeight = this.adminBar.getBoundingClientRect().height;
      } else {
        this.adminBarHeight = 0;
      }

      this.headerHeight = this.header.getBoundingClientRect().height;

      window.onscroll = function () {
        return _this.scrollFunction();
      };
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.scrollingUp = this.scrollTop < this.lastScrollTop;

      if (this.adminBar) {
        this.adminBarHeight = this.adminBar.getBoundingClientRect().height;
      }

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.backToTopOffset = this.headerHeight + this.adminBarHeight;

      if (this.scrollTop > this.toggleDistance && this.scrollingUp) {
        this.$backToTop.addClass('active');
        this.$backToTop.css('top', this.backToTopOffset);
      } else {
        this.$backToTop.removeClass('active');
        this.$backToTop.css('top', 0);
      }

      this.lastScrollTop = this.scrollTop <= 0 ? 0 : this.scrollTop;
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = plugin;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Generate a jQuery plugin
 * @param pluginName [string] Plugin name
 * @param className [object] Class of the plugin
 * @param shortHand [bool] Generate a shorthand as $.pluginName
 *
 * @example
 * import plugin from 'plugin';
 *
 * class MyPlugin {
 *     constructor(element, options) {
 *         // ...
 *     }
 * }
 *
 * MyPlugin.DEFAULTS = {};
 *
 * plugin('myPlugin', MyPlugin');
 */
function plugin(pluginName, className) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dataName = "__".concat(pluginName);
  var old = $.fn[pluginName];

  $.fn[pluginName] = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data(dataName);
      var options = $.extend({}, className.DEFAULTS, $this.data(), _typeof(option) === 'object' && option);

      if (!data) {
        $this.data(dataName, data = new className(this, options));
      }

      if (typeof option === 'string') {
        data[option]();
      }
    });
  }; // - Short hand


  if (shortHand) {
    $[pluginName] = function (options) {
      return $({})[pluginName](options);
    };
  } // - No conflict


  $.fn[pluginName].noConflict = function () {
    return $.fn[pluginName] = old;
  };
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Used to lazy load videos. Videos must use a fixed HTML construct
 * Note: for this to work, HTML comments must NOT be stripped with performance plugin
 * @example 
 *  <div class="js-lazy-load-video" style="background-image: url('poster.jpg');">
 *   <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/q6EoRBvdVPQ?autoplay=1&amp;rel=0&amp;controls=0" frameborder="0" allowfullscreen></iframe>-->
 *  </div>
 */
var LazyLoadVideos =
/*#__PURE__*/
function () {
  function LazyLoadVideos() {
    _classCallCheck(this, LazyLoadVideos);

    // Check if exists and initialize
    this.$lazyLoadVideos = $('.js-lazy-load-video');
    this.$lazyLoadModalButton = $('.js-open-lazy-modal-video');

    if (this.$lazyLoadVideos.length > 0) {
      // console.log( 'initializing video lazy loading' );
      this.init();
    }

    if (this.$lazyLoadModalButton.length > 0) {
      // console.log( 'initializing lazy loaded modal video' );
      this.initLazyModalVideo();
    }
  }

  _createClass(LazyLoadVideos, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)       
      this.$lazyLoadVideos.on("click", function (e) {
        return _this.handleVideoClick(e);
      });
    }
  }, {
    key: "initLazyModalVideo",
    value: function initLazyModalVideo() {
      var _this2 = this;

      var targetModalId = this.$lazyLoadModalButton.attr('data-modal-target');
      var $targetModal = $('#' + targetModalId);
      var $modalLazyVideo = $targetModal.find('.js-lazy-load-modal-video');
      var $modalBackdrop = $targetModal.parents('.oxy-modal-backdrop');
      var $modalCloseButton = $targetModal.find('.js-modal-close-btn');

      if ($modalLazyVideo.length > 0) {
        this.$lazyLoadModalButton.on('click.openlazymodal', function (e) {
          _this2.handleLazyModalVideoButtonClick(e, $modalLazyVideo);
        });
      } else {
        console.log('Error: found lazy load button, but couldn\'t find target video with .js-lazy-load-modal-video class');
      }

      $modalBackdrop.on('click', function () {
        _this2.stopVideo($modalLazyVideo);
      }); //$modalCloseButton.on( 'click' , () => { this.stopVideo( $modalLazyVideo ) } );
    }
  }, {
    key: "stopVideo",
    value: function stopVideo($el) {
      // console.log( 'stopping video' );
      //$el.find( 'iframe' ).get(0).contentWindow.postMessage('{"event":"command","func":"stopVideo","args":[]}', '*');
      $el.find('iframe').removeAttr('src', "");
    }
  }, {
    key: "handleVideoClick",
    value: function handleVideoClick(e) {
      // console.log( 'lazy loaded video clicked' );
      var $elm = $(e.currentTarget);
      this.loadVideo($elm);
    }
  }, {
    key: "handleLazyModalVideoButtonClick",
    value: function handleLazyModalVideoButtonClick(e, $modalVideo) {
      // console.log( 'lazy loaded modal video initializing' );
      // console.log( $modalVideo.find('iframe') );
      if ($('body').hasClass('lazy-modal-initialized')) {
        $modalVideo.find('iframe').attr('src', this.modalVideoSrc);
      } else {
        this.loadVideo($modalVideo);
        $('body').addClass('lazy-modal-initialized');
        this.modalVideoSrc = $modalVideo.find('iframe').attr('src');
      }
    }
  }, {
    key: "loadVideo",
    value: function loadVideo($element) {
      // console.log( 'loading element: ' + $element.contents() );
      var $elm = $element,
          conts = $elm.contents(),
          le = conts.length,
          ifr = null;

      for (var i = 0; i < le; i++) {
        if (conts[i].nodeType == 8) ifr = conts[i].textContent;
      }

      $elm.addClass("player").html(ifr);
      $elm.off("click");
    }
  }]);

  return LazyLoadVideos;
}();

var _default = LazyLoadVideos;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var ToC =
/*#__PURE__*/
function () {
  function ToC() {
    _classCallCheck(this, ToC);

    // Check if exists and initialize
    this.$toc = $('.pro-table-of-contents');

    if (this.$toc.length > 0) {
      this.init();
    }
  }

  _createClass(ToC, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Check if ToC is expanded onLoad
      this.$toc_button = this.$toc.find('.oxy-toc > button');
      var mediaQuery = window.matchMedia('(max-width: 767px)');

      if (mediaQuery.matches && this.$toc_button.hasClass('active')) {
        this.collapseToC();
      }

      var isExpanded = this.$toc_button.hasClass('active'); // Add .active class to pro element

      if (isExpanded) {
        this.$toc.addClass('active');
      } // Toggle .active class on click


      this.$toc_button.on('click', function () {
        _this.$toc.toggleClass('active');
      }); // Get the offset of the ToC

      this.$toc_parent = this.$toc.parent();
      this.toc_offset = this.$toc_parent.offset();
      this.toc_max_offset = this.toc_offset.top + this.$toc_parent.outerHeight(false); // console.log(this.toc_offset.top);
      // console.log(this.toc_max_offset);
      // Create scroll event listener for sticky ToC

      $(window).on('scroll', function (e) {
        return _this.stickyTocWatcher(e);
      }); // Set the starting state of the ToC based on load position

      var startingPosition = $(window).scrollTop();
      this.setTocStickyState(startingPosition); // Mobile Only - Wait until all ToC items have been generated and then wire up handler to collapse ToC if any links are clicked

      if (mediaQuery.matches) {
        setTimeout(function () {
          // Toggle the ToC closed if any ToC links are clicked
          $('.oxy-toc .toc-list li a').on('click', function () {
            _this.$toc_button.click();
          });
        }, 500);
      }
    }
    /**
    *   We need to check if the user has scrolled and pass that
    *   scroll distance to our state handler
    **/

  }, {
    key: "stickyTocWatcher",
    value: function stickyTocWatcher(e) {
      var scrollDistance = e.currentTarget.pageYOffset;
      this.setTocStickyState(scrollDistance); // console.log(scrollDistance);
    }
    /**
    *   State Handler: set the state based on scrollDistance and original offset
    **/

  }, {
    key: "setTocStickyState",
    value: function setTocStickyState(scrollDistance) {
      if (scrollDistance > this.toc_offset.top & scrollDistance < this.toc_max_offset) {
        this.$toc.addClass('sticky');
      } else {
        this.$toc.removeClass('sticky');
      }
    }
  }, {
    key: "collapseToC",
    value: function collapseToC() {
      //collapse ToC
      console.log('trying to collapse...');
      this.$toc_button.removeAttr('style');
      this.$toc_button.removeClass('active');
      this.$toc.removeClass('active');
    }
  }]);

  return ToC;
}();

var _default = ToC;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Script for Responsive Tabs component
 * @example 
 * http://www.entheosweb.com/tutorials/css/tabs.asp
 */
var ResponsiveTabs =
/*#__PURE__*/
function () {
  function ResponsiveTabs(element) {
    _classCallCheck(this, ResponsiveTabs);

    if ($(element).length > 0) {
      this.init(element);
    }
  }

  _createClass(ResponsiveTabs, [{
    key: "init",
    value: function init(element) {
      var _this = this;

      this.$tabsObj = $(element); // Initialize all tab containers and elements to reference

      this.$tabsContainer = this.$tabsObj.find(".tab_container");
      this.$tabs = this.$tabsObj.find('.tabs');
      this.$tabContent = this.$tabsObj.find(".tab_content"); // Hide all tab contents except the first one

      this.$tabsContainer.find('.tab_content').hide();
      this.$tabsContainer.find('.tab_content:first').show();
      this.$drawerToggleIcons = $('.tab_container .oxy-expand-collapse-icon'); // Set the height of the minimum height of the tab container (contains tab contents)
      // to the height of the tabs
      // this.$tabsContainer.css("min-height", () => { 
      //     return this.$tabs.outerHeight() + 50;
      // });

      /* Bind event handler for tabs clicks */

      this.$tabs.find('li').click(function (e) {
        return _this.handleTabClick(e);
      });
      /* Bind event handler for tabs clicks if in drawer mode */

      this.$tabsContainer.find(".tab_drawer_heading").click(function (e) {
        return _this.handleDrawerTabClick(e);
      });
      /* Uncomment to add extra class "tab_last" to last tab */
      //this.$tabs.find('li').last().addClass("tab_last");
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(e) {
      // Hide all tabs contents
      this.$tabContent.hide(); // Get the "rel" value (ID of the contents to display)

      var activeTabID = $(e.currentTarget).attr("rel"); // Fade in the contents for the active tab. Store reference to active tab just in case

      this.$activeTab = this.$tabsContainer.find("#" + activeTabID).fadeIn(); // Remove active class from all tabs

      this.$tabs.find("li").removeClass("active"); //Add active class to tab item that was clicked

      $(e.currentTarget).addClass("active"); // Remove d_active class from drawer heading

      this.$tabsContainer.find(".tab_drawer_heading").removeClass("d_active"); // Add active class to respective drawer heading for the tab that was clicked 

      this.$tabsContainer.find(".tab_drawer_heading[rel^='" + activeTabID + "']").addClass("d_active"); // this.$tabs.css('min-height', 0);
      // // this.$tabsContainer.css("min-height", () => { 
      // //     return this.$tabs.outerHeight() + 50;
      // // });
    }
  }, {
    key: "handleDrawerTabClick",
    value: function handleDrawerTabClick(e) {
      // Hide all tabs contents
      this.$tabContent.hide();
      var $clickTarget = $(e.currentTarget);
      console.log(e); // Remove d_active class from drawer heading

      this.$tabsContainer.find(".tab_drawer_heading").removeClass("d_active"); // Get the "rel" value (ID of the contents to display)

      var d_activeTabID = $(e.currentTarget).attr("rel"); // Fade in the contents for the active tab. Store reference to active tab just in case

      this.$tabsContainer.find("#" + d_activeTabID).fadeIn(); // this.$tabsContainer.find("#"+d_activeTabID).show();
      // Add active class to respective drawer heading for the tab that was clicked 

      $clickTarget.addClass("d_active");
      this.$drawerToggleIcons.addClass('oxy-eci-collapsed');
      $clickTarget.find('.oxy-expand-collapse-icon').removeClass('oxy-eci-collapsed'); // Remove active class from all tabs

      this.$tabs.find("li").removeClass("active"); //Add active class to tab item that was clicked

      this.$tabs.find("li[rel^='" + d_activeTabID + "']").addClass("active"); // this.$tabs.css('min-height', 0);
      // this.$tabs.css("min-height", () => { 
      //     return this.$tabsContainer.outerHeight() + 50;
      // });
    }
  }]);

  return ResponsiveTabs;
}();

var _default = ResponsiveTabs;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Opens social sharing links in a small popup window
 * @example 
 * 1. Add the class .js-social-share-popup to social share links
 */
var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],7:[function(require,module,exports){
"use strict";

var _jqueryPlugin = _interopRequireDefault(require("./modules/jquery-plugin"));

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _responsiveTabs = _interopRequireDefault(require("./modules/responsive-tabs-2"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _lazyLoadVideos = _interopRequireDefault(require("./modules/lazy-load-videos"));

var _proTableOfContents = _interopRequireDefault(require("./modules/pro-table-of-contents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
// import $ from 'jquery';
window.$ = jQuery; //import Sample from './modules/sample-module.js';

$(document).ready(function () {
  $('html').addClass('js-on-load');
  var backToTop = new _backToTop.default(); // const responsiveTabs = new ResponsiveTabs();

  var socialSharePopups = new _socialSharePopups.default();
  var lazyLoadVideos = new _lazyLoadVideos.default();
  var toc = new _proTableOfContents.default();
  (0, _jqueryPlugin.default)('ResponsiveTabs', _responsiveTabs.default);
  var $responsiveTabs = $('.responsive-tabs-component');

  if ($responsiveTabs.length > 0) {
    $responsiveTabs.ResponsiveTabs();
  }
});

},{"./modules/back-to-top":1,"./modules/jquery-plugin":2,"./modules/lazy-load-videos":3,"./modules/pro-table-of-contents":4,"./modules/responsive-tabs-2":5,"./modules/social-share-popups":6}]},{},[7]);
